import {
  useThemeColors,
  onThemeChange,
} from "../../core";

const EVENT = {
  USER_SKIN_CHANGE: 'userSkinchange',
};

export default {
  mounted() {
    // 这是在iframe中时用的处理
    window.addEventListener('message', onThemeChange);

    // 这是直接在Web框架中（不会有iframe的postMessage通知）用的
    if (this.$eventService && this.$eventService.eventBus && this.$eventService.eventBus.on) {
      this.$eventService.eventBus.on(EVENT.USER_SKIN_CHANGE, (skin, val) => {
        onThemeChange({
          data: {
            type: 'USER_SKIN_CHANGE',
            ThemeColor: {
              Color: getComputedStyle(document.documentElement).getPropertyValue("--theme-background-color"),
              ColorHover: getComputedStyle(document.documentElement).getPropertyValue("--input-hover-color"),
              ColorBackground: getComputedStyle(document.documentElement).getPropertyValue("--theme-background-color-new"),
              ColorFocus: getComputedStyle(document.documentElement).getPropertyValue("--layout-background-color-choose"),
            }
          }, skin
        });
      });
    }
    useThemeColors();
  },
  beforeDestroy() {
    window.removeEventListener('message', onThemeChange);
  }
};
